import Vue from 'vue'
import Router from 'vue-router'
// import { hasIntersect } from '@common/js/common'
import { routes } from '../js/menu.js'
import store from '../vuex/store'
import { normalizeLocale, setStoredLocale } from '@/js/common'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: routes,
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

let goToNext = (to, next, router) => {
  next()
  let title = to.meta.title
  if(to.name === 'campaign-create'&&to.query.type === 'detail'){
    title = this.$t('messages.createCampaign.create110')
  }
  Vue.prototype.setTitle(title)
  store.commit('ACTIVE_MENU', to.path)
}

const syncLocaleFromRoute = (to, vm) => {
  if (!['login', 'register'].includes(to.name)) return
  const locale = normalizeLocale(to.params.lang)
  if (locale && vm && vm.$i18n) {
    vm.$i18n.locale = locale
    setStoredLocale(locale)
  }
}

router.beforeEach((to, from, next) => {console.log('beforeEach',);
  const vm = router.app
  syncLocaleFromRoute(to, vm)
  let ignore = [
    // '/googleLogin',
    // '/login',
    // '/register',
    '/zh-cn/login',
    '/zh-cn/register',
    '/en-us/login',
    '/en-us/register',
    '/terms',
    '/privacy',
    '/reset-psw',
    '/user-verify',
    '/token-invalid',
  ]
  let loginsRegs = ['/zh-cn/login','/zh-cn/register','/en-us/login','/en-us/register']
  if (~ignore.indexOf(to.path)) {
    document.title = to.name ? `ASOGrow | ${to.name}` : 'ASOGrow'
    if(loginsRegs.includes(to.path)){
      document.querySelectorAll('meta[name="description"], meta[name="keywords"]').forEach(tag => {
        tag.remove()
      })
    }

    if ((to.path === '/zh-cn/login' || to.path === '/en-us/login' || to.path === '/zh-cn/register' || to.path === '/en-us/register')
      && JSON.stringify(to.query)==='{}' && JSON.stringify(from.query)!=='{}') {
      next({path: to.path, query: from.query})
    } else {
      next()
    }

  } else {
    if (((!vm._isMounted && to.name !== 'login')&&(!vm._isMounted))) {
      vm.$options.store.dispatch('getProfile').then(() => {
        goToNext(to, next, router)
      })
    } else {
      goToNext(to, next, router)
    }
  }
  // let dom = document.getElementById('description');
  // if(to.name === 'login' || to.name === 'register'){
  //   if (to.meta.content) {
      
  //     dom.content = to.meta.content
  //    }
  //   if (to.meta.title) {
  //     document.title = to.meta.title;
  //   }
  // }else if(dom){
  //   let head = document.getElementsByTagName('head');
  //   head[0].removeChild(dom)
  // }
})

export default router
